// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"95":"113c1012","511":"34880cb6","533":"125a61ad"}[chunkId] + ".css";
};